module.exports = __webpack_public_path__ + "static/img/logo-small.dbbdf190.svg";